export enum TemplatesRoutes {
  root = 'templates',
  main = '',
}
